import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { financingBrokerageServiceConfigSchema } from '../configurations/FinancingBrokerageServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderFinancingBrokerageDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.FINANCING_BROKERAGE]: financingBrokerageServiceConfigSchema,
    }),
});

export { servicesProviderFinancingBrokerageDataSchema };
//# sourceMappingURL=ServicesProviderFinancingBrokerageData.js.map
